module.exports = __webpack_public_path__ + "static/media/amex.76e17957.svg";